import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { PaymentMoment, PaymentAcquirer, Deliverymethodkind } from './Enums'
/**
* Class WebChannelPaymentMethodDto
*  Публичная карточка способа оплаты в настройках витрины
*/
export class WebChannelPaymentMethodDto extends ActiveModel {

  /**
  * id
  *   */
  @ActiveField(0)
  id: number = 0


/**
  * methodCode
  * Код метода из реестра способов оплаты
  */
  @ActiveField('')
  methodCode: string = ''


/**
  * name
  * Отображаемое название.
  */
  @ActiveField('')
  name: string = ''


  /**
  * order
  * Порядковый номер<br>  */
  @ActiveField(0)
  order: number = 0


  /**
  * moment
  * словарь значений публикуется под именем `Domain.Entities.Channels.PaymentMoment`  *   * Момент оплаты по данным реестра методов шлюза  *   * - `Prepayment` Предоплата  *   * Предоплата при оформлении заказа.  * - `OnReceipt` При получении  *   * Оплата при получении заказа.  *   */
  @ActiveField(PaymentMoment.PREPAYMENT)
  moment: PaymentMoment = PaymentMoment.PREPAYMENT


  /**
  * acquirer
  * словарь значений публикуется под именем `Domain.Entities.Channels.PaymentAcquirer`  *   * Кто принимает деньги (по данным реестра методов шлюза)  *   * - `Gateway` Платёжный шлюз  *   * Платёжный шлюз, подключённый у продавца (сейчас — T-Bank).  * - `Seller` Продавец на месте  *   * Продавец на месте: касса магазина или склада.  * - `Carrier` Служба доставки  *   * Служба доставки (наложенный платёж).  *   */
  @ActiveField(PaymentAcquirer.GATEWAY)
  acquirer: PaymentAcquirer = PaymentAcquirer.GATEWAY


/**
  * allowedDeliveryKinds
  * Виды доставки, с которыми допустим способ. Пустой список — ни с одним видом.<br>Витрина показывает способ только под подходящую доставку, сервер проверяет то же при оплате.<br>  */
  @ActiveField({
    setter(model: WebChannelPaymentMethodDto, prop: string, value: Array<Deliverymethodkind>, receiver?: WebChannelPaymentMethodDto ) {
      return Reflect.set(
        model,
        prop,
        value ?  (Array.isArray(value) ? value : [value]) : value, 
        receiver)
    }
  })
  allowedDeliveryKinds: Array<Deliverymethodkind> = []


  /**
  * maxOrderAmount
  * Потолок суммы заказа (Domain.Entities.Orders.Order.Payable), при котором способ доступен; null — без лимита.  */
  @ActiveField()
  maxOrderAmount?: null | number


  /**
  * registeredOnly
  * Способ доступен только зарегистрированным покупателям (анонимный чекаут отклоняется).  */
  @ActiveField()
  registeredOnly?: boolean
}
